import { type ParallelCommandJob } from "../lib/types/CommandJob";

export const ParallelJobIndex = ({ job }: { job: ParallelCommandJob }) => {
  return (
    <span className="inline-block rounded-[3px] border border-current bg-white px-0.5 text-xs">
      {`${job.parallelGroupIndex + 1}/${job.parallelGroupTotal}`}
    </span>
  );
};
